import React from 'react';
import { Flex, Button } from '@goodrx/matisse';
import { SectionTitle } from 'app/components/SectionTitle';
import { PaymentRequestMain } from 'app/components/payment/PaymentRequestMain';
import { PaymentWidget } from 'app/components/payment/PaymentWidget';
import { PaymentWidgetReturnType, WidgetStates } from 'app/components/payment/types';

export const CheckoutForm = ({
  paymentRequest,
  hideHeader,
  ...props
}: PaymentWidgetReturnType & { hideHeader?: boolean }) => {
  const showHeader = props.paymentState === WidgetStates.LIST || !hideHeader;
  return (
    <PaymentWidget {...props}>
      <Flex mb={showHeader ? 20 : 0} mt={{ _: 0, md: '24px' }} alignItems="center" justifyContent="space-between">
        {showHeader && (
          <>
            <Flex flexDirection="column">
              <SectionTitle mb={0}>
                {props.paymentState === WidgetStates.LIST ? 'Choose Payment Method' : 'Add Payment Method'}
              </SectionTitle>
            </Flex>
            {!!props.paymentMethods?.length && (
              <>
                {props.paymentState === WidgetStates.LIST ? (
                  <Button variant="primaryText" mr={-3} onClick={() => props.setPaymentState(WidgetStates.FORM)}>
                    + Add Card
                  </Button>
                ) : (
                  <Button variant="greyText" mr={-3} onClick={() => props.setPaymentState(WidgetStates.LIST)}>
                    Cancel
                  </Button>
                )}
              </>
            )}
          </>
        )}
      </Flex>

      {paymentRequest && (
        <PaymentRequestMain amount={paymentRequest.amount} onTokenReceived={paymentRequest.onTokenReceived} />
      )}
    </PaymentWidget>
  );
};
